const meta = {
  'use-events': 'View and create',
  'enable-events': 'Enable events',
};

export default meta;
